module.exports = __webpack_public_path__ + "static/img/1-2.cd2a846.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/1-2.png
// module id = HJMe
// module chunks = 0